import { useMemo } from 'react';
import { usePrefs } from 'wsm-common-data';
import { useMyCarsSiteProperties } from './useMyCarsSiteProperties';
import { calculateFooterCTAVisibility } from '../utilities/footerCTAs';

/**
 * Custom hook to manage footer CTA visibility logic with memoization
 * @returns {Object} Footer CTA configuration and helper functions
 */
export const useFooterCTAs = () => {
	const { displaySaveIconOn, removeFooterLinks, enableCompare } = usePrefs();
	const { enableMyCars } = useMyCarsSiteProperties();

	return useMemo(
		() =>
			calculateFooterCTAVisibility(
				removeFooterLinks,
				displaySaveIconOn,
				enableMyCars,
				enableCompare
			),
		[removeFooterLinks, displaySaveIconOn, enableMyCars, enableCompare]
	);
};
